// @import dependencies
import React, {Component} from 'react'
// @end

// @import components
import {WebinarsScreenLayout} from 'app_components/screens/landing/webinars'
// @end

// @ADD Component types
interface IWebinarsScreenProps {}
interface IWebinarsScreenState {}

class WebinarsScreen extends Component<IWebinarsScreenProps, IWebinarsScreenState> {

  /*===============================================
  =            Estructura de un metodo            =
  ================================================
    // La estructura de un metodo debe ser la siguiente:
    methodName = () => {}
  /*======  End of Estructura de un metodo  =====*/

  constructor(props: IWebinarsScreenProps) {
    super(props)
    this.state = {}
  }

  render() {
    return(
      <WebinarsScreenLayout
        {...this.props}
      />
    )
  }
}

export default WebinarsScreen
